<template>
  <b-modal
    :visible="visible"
    title="ربط الاستيلاء"
    ok-title="ربط"
    cancel-title="إلغاء"
    :ok-disabled="busy || !selectedParcelId"
    @change="$emit('update:visible', $event)"
    @ok.prevent="submit"
  >
    <div
      v-if="loading"
      class="text-center py-2"
    >
      <b-spinner variant="primary" />
    </div>
    <div v-else>
      <p class="mb-1">
        اختر القطعة لربطها بخريطة (حوض + رقم حوض + رقم قطعة)
      </p>
      <b-form-select
        v-model="selectedParcelId"
        :options="parcelOptions"
        class="mb-1"
      />
      <div v-if="needMap">
        <p class="mb-50">
          وُجد أكثر من تطابق. اختر الخريطة أو قطعة الخريطة.
        </p>
        <b-form-select
          v-model="cadastralMapId"
          :options="mapOptions"
          class="mb-1"
        />
        <b-form-select
          v-if="mapParcelOptions.length"
          v-model="cadastralMapParcelId"
          :options="mapParcelOptions"
        />
      </div>
    </div>
  </b-modal>
</template>

<script>
import { BModal, BFormSelect, BSpinner } from 'bootstrap-vue'
import seizureLandInventoriesApi from '@/api/seizure-land-inventories/seizureLandInventories'
import {
  inventoryFromResponse,
  unwrapList,
  inventoryLocations,
  mapDisplayName,
} from '../formModel'

export default {
  name: 'SliLinkSeizureModal',
  components: { BModal, BFormSelect, BSpinner },
  props: {
    visible: { type: Boolean, default: false },
    inventoryId: { type: [Number, String], default: null },
  },
  data() {
    return {
      loading: false,
      busy: false,
      inventory: null,
      maps: [],
      selectedParcelId: null,
      cadastralMapId: null,
      cadastralMapParcelId: null,
      needMap: false,
    }
  },
  computed: {
    parcels() {
      return inventoryLocations(this.inventory)
    },
    parcelOptions() {
      return this.parcels.map((p, i) => ({
        value: p.id,
        text: `قطعة ${i + 1}${p.land_number || p.parcel_number ? ` — ${p.land_number || p.parcel_number}` : ''}${p.basin_name ? ` — ${p.basin_name}` : ''}${p.linked || p.cadastral_map_parcel_id ? ' (مربوطة)' : ''}`,
        disabled: !p.id,
      }))
    },
    mapOptions() {
      return [{ value: null, text: 'اختر الخريطة' }].concat(
        this.maps.map(m => ({ value: m.id, text: mapDisplayName(m) })),
      )
    },
    selectedMap() {
      return this.maps.find(m => String(m.id) === String(this.cadastralMapId)) || null
    },
    mapParcelOptions() {
      const parcels = this.selectedMap?.parcels || []
      if (!Array.isArray(parcels) || !parcels.length) return []
      return [{ value: null, text: 'قطعة الخريطة (اختياري)' }].concat(
        parcels.map(p => ({
          value: p.id,
          text: [p.basin_name, p.basin_number, p.parcel_number || p.land_number].filter(Boolean).join(' — ') || `#${p.id}`,
        })),
      )
    },
  },
  watch: {
    visible(val) {
      if (val) this.open()
    },
  },
  methods: {
    firstUnlinkedId() {
      const unlinked = this.parcels.find(p => p.id && !p.linked && !p.cadastral_map_parcel_id)
      const first = unlinked || this.parcels.find(p => p.id)
      return first ? first.id : null
    },
    open() {
      this.needMap = false
      this.cadastralMapId = null
      this.cadastralMapParcelId = null
      if (!this.inventoryId) return
      this.loading = true
      Promise.all([
        seizureLandInventoriesApi.show(this.inventoryId),
        seizureLandInventoriesApi.listMaps({ per_page: 100 }),
      ])
        .then(([invRes, mapsRes]) => {
          this.inventory = inventoryFromResponse(invRes)
          const { rows } = unwrapList(mapsRes)
          this.maps = rows
          this.selectedParcelId = this.firstUnlinkedId()
        })
        .catch(() => {
          this.$toast.error('تعذر تحميل القطع للربط')
        })
        .finally(() => {
          this.loading = false
        })
    },
    submit() {
      if (!this.inventoryId || !this.selectedParcelId) return
      this.busy = true
      const body = this.needMap
        ? (this.cadastralMapParcelId
          ? { cadastral_map_parcel_id: this.cadastralMapParcelId }
          : { cadastral_map_id: this.cadastralMapId })
        : { auto: true }
      seizureLandInventoriesApi.linkParcel(this.inventoryId, this.selectedParcelId, body)
        .then(() => {
          this.$toast.success('تم ربط الاستيلاء')
          this.$emit('linked')
          this.$emit('update:visible', false)
        })
        .catch(err => {
          const status = err?.response?.status
          const message = err?.response?.data?.message || ''
          if (status === 422 && /more than one|أكثر من/i.test(String(message))) {
            this.needMap = true
            this.$toast.error(message || 'يوجد أكثر من تطابق — اختر الخريطة')
            return
          }
          this.$toast.error(message || 'تعذر ربط الاستيلاء')
        })
        .finally(() => {
          this.busy = false
        })
    },
  },
}
</script>
